import adhesiveImage from "./images/adhesive.jpg";
import bagUpsellImage from "./images/bag.jpg";
import ceweFixationClipImage from "./images/cewe_fixation_clip.jpg";
import ceweFixationVisImage from "./images/cewe_fixation_vis.jpg";
import emojiStickersUpsellImage from "./images/emoji_stickers.jpg";
import fairyLightsUpsellImage from "./images/fairy_lights.jpg";
import fastenerUpsellImage from "./images/fastener.jpg";
import frames10x10UpsellImage from "./images/frames_10x10.jpg";
import frames11x15UpsellImage from "./images/frames_11x15.jpg";
import frames15x20UpsellImage from "./images/frames_15x20.jpg";
import frames20x20UpsellImage from "./images/frames_20x20.jpg";
import frames20x30UpsellImage from "./images/frames_20x30.jpg";
import framesPrintsUpsellImage from "./images/frames_prints.jpg";
import hookUpsellImage from "./images/hook.jpg";
import littleScrapbookUpsellImage from "./images/little_scrapbook.jpg";
import metallicFrameImage from "./images/metallic-prints-frame.jpg";
import metallicHangerImage from "./images/metallic-prints-hanger.jpg";
import ribbonUpsellImage from "./images/ribbon.jpg";
import slimMaskingTapesUpsellImage from "./images/slim_masking_tapes.jpg";

interface AuthorizedUpsell {
  tag: string;
  imageUrl: string;
}

export const authorizedUpsells: AuthorizedUpsell[] = [
  { tag: "bag", imageUrl: bagUpsellImage },
  { tag: "chassis", imageUrl: metallicHangerImage },
  { tag: "caisse_americaine", imageUrl: metallicFrameImage },
  { tag: "emoji_stickers", imageUrl: emojiStickersUpsellImage },
  { tag: "fairy_lights", imageUrl: fairyLightsUpsellImage },
  { tag: "fastener", imageUrl: fastenerUpsellImage },
  { tag: "fixation_clip", imageUrl: ceweFixationClipImage },
  { tag: "fixation_vis", imageUrl: ceweFixationVisImage },
  { tag: "frame", imageUrl: framesPrintsUpsellImage },
  { tag: "frames_10x10", imageUrl: frames10x10UpsellImage },
  { tag: "frames_11x15", imageUrl: frames11x15UpsellImage },
  { tag: "frames_15x20", imageUrl: frames15x20UpsellImage },
  { tag: "frames_20x20", imageUrl: frames20x20UpsellImage },
  { tag: "frames_20x30", imageUrl: frames20x30UpsellImage },
  { tag: "hook", imageUrl: hookUpsellImage },
  { tag: "little_scrapbook", imageUrl: littleScrapbookUpsellImage },
  { tag: "adhesive", imageUrl: adhesiveImage },
  { tag: "ribbon", imageUrl: ribbonUpsellImage },
  { tag: "slim_masking_tapes", imageUrl: slimMaskingTapesUpsellImage },
  { tag: "velcro", imageUrl: fastenerUpsellImage },
];
